import { useCallback, useState } from 'react';
import { Box } from '@chakra-ui/react';

import { Form } from '@app/components/common/form/form';
import Dialog from '@app/components/common/modals/dialog';
import { FieldView, TextField } from '@app/components/common';
import { useAlert, useApi, useEntityState } from '@app/hooks';
import { useQueryTable } from '@app/components/common/table/query-table';

import { CreateTxInstance, FormProps } from './types';
import { EquipField } from './components/EquipField';
import { OutletField } from './components/OutletField';
import { TX_TYPE_CORRECTION } from '../transactions/mock/tx-types';

export const CorrectionForm = ({ open, onCancel, onSubmit }: FormProps) => {
  const [instance, onChange] = useEntityState<CreateTxInstance>({
    type: TX_TYPE_CORRECTION
  });
  const [loading, setLoading] = useState(false);
  const { acb } = useApi();
  const { error } = useAlert();
  const { refetch } = useQueryTable();

  const onSubmitForm = async (instance: CreateTxInstance) => {
    if (!instance.equip) {
      error('Не выбрано ХО');
      return;
    }
    setLoading(true);

    await onSubmit(instance);
    await refetch();
    setLoading(false);
  };

  const onOutletToChange = useCallback(async (value: EntityBase) => {
    if (!value?.id) {return;}
    setLoading(true);
    const outlet = await acb.getMasterOutlet(Number(value.id));
    if (!outlet?.data?.distributor) {
      error('Ошибка определения дистрибьютора');
      setLoading(false);
      return;
    }
    if (!outlet.data.room_type) {
      error('Для данной ТТ не указан тип (склад/ТТ/офис)');
      onChange('to')(undefined);
      setLoading(false);
      return;
    }
    onChange('distr')(outlet.data.distributor);
    setLoading(false);
  }, []);

  const isValid = !!instance.equip && !!instance.to;

  return <Dialog 
    open={open} 
    onClose={onCancel}
    loading={loading}
    title="Корректировка"
    width='fit-content'
  >
    <Box mb={-4} minW={{ md: '600px' }}>
      <Form<CreateTxInstance>
        instance={instance} 
        onChange={onChange}
        onSubmit={onSubmitForm} 
        onCancel={onCancel}
        submitText="Создать"
        disabled={!isValid}
      >
        <Form.Item 
          span={{ md: 12 }}
          field='equip'
          component={EquipField}
        />
        <Form.Spacer>
          {instance?.from && <FieldView 
            title="ТТ отправления"
            value={<>
              instance?.from?
            </>}
          />}
        </Form.Spacer>
        <Form.Item<CreateTxInstance, EntityBase>
          span={{ md: 12 }}
          label="Точка назначения"
          field='to'
          required
          component={OutletField}
          onChange={onOutletToChange}
        />
        <Form.Item 
          span={{ md: 12 }}
          label='Комментарий'
          field='comment'
          component={TextField} 
          componentProps={{ multiline: true }} 
        />
      </Form>
    </Box>
  </Dialog>;
};